import * as React from "react";


export const IconHomeWork = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_6252_37717)">
      <path d="M8.17 5.69922L1 10.4792V20.9992H6V12.9992H10V20.9992H15V10.2492L8.17 5.69922Z" fill="white" />
      <path
        d="M10 3V4.51L12 5.84L13.73 7H15V7.85L17 9.19V11H19V13H17V15H19V17H17V21H23V3H10ZM19 9H17V7H19V9Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_6252_37717">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
